import { useEffect, useState } from "react";
import { getByRegistroReferencia, putOne } from "../../../../database/dbRegistroGeneral";
import { Avatar, Box, Button, Container, createTheme, CssBaseline, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, TextField, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { logObject } from "../../../../utils/validations";
import { setBodyFirstMail, setBodyNotification, setBodyPersonalEmailLink } from "../emails/bodies";
import Swal from "sweetalert2";
import { CustomDialog } from "../../../modules/dialogs/CustomDialog";
import { renderToString } from "react-dom/server";
import { sendEmail } from "../../../../services/sendEmail";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { createButton } from "../../../../helpers/html/createButton";


const eventLogo = "https://eventos.cibnor.mx/intranet/img/logo_sina2025.png";


export const Sina2025TrabajosRevision = () => {

    const queryParameters = new URLSearchParams(window.location.search)
    const ref = queryParameters.get("id")


    const [record, setRecord] = useState({});
    const [works, setWorks] = useState([]);

    const [isDataLoaded, setisDataLoaded] = useState(false);


    //*
    const updateWork = (id, field, value) => {

        const workIndex = works.findIndex(w => w.id === id);
        const worksTmp = JSON.parse(JSON.stringify(works));
        worksTmp[workIndex][field] = value;

        setWorks(worksTmp);
    }


    const handleWorkCommentsChanged = ({ target }) => {
        const { value, name } = target;
        updateWork(name, 'statusComments', value);
    }
    
    const handleWorkStatusChanged = ({ target }) => {
        // console.log(target);
        const { value, name } = target;
        updateWork(name, 'status', value);
    }

    const handleGuardarCambios = async() => {
        console.log({record});
        logObject(works);
        // Generamos la copia de infoAdicional;
        const infoAdicionalTmp = JSON.parse(JSON.stringify(record.infoAdicional));
        // Actualizamos los trabajos con el state actual
        infoAdicionalTmp.trabajos = works;
        
        // Contruimos el objeto para actualizar el registro
        const recordToSave = { ...record, infoAdicional: JSON.stringify(infoAdicionalTmp) };
        console.log({recordToSave});
        
        // Se actualiza el registro
        const { exito } = await putOne(record.id, recordToSave);
        
        
        if (exito) {
            console.log({infoAdicionalTmp});
            setRecord({ ...record, infoAdicional: infoAdicionalTmp });
            Swal.fire({
                title: '¡Registro actualizado!',
                text: 'Puede cerrar la ventana o continuar modificando.',
                showConfirmButton: false,
                timer: 3000
            })
        } else {
            Swal.fire({
                title: '¡Error al actualizar!',
                text: 'Presione -Ok-, tome una captura de pantalla y notifique al desarrollador.',
                icon: 'error',
            })
        }
    }

    const handleReenviarRecordatorio = async() => {
        setisDataLoaded(false);
        logObject(record);
        
        //* Armar el correo de acuse y enviarlo
        const datosRegistro = {
            tituloEvento: 'Simposio Internacional en Nutrición Acuícola',
            correoEvento: 'sina2025@cibnor.mx',
            urlLogo: eventLogo,
            modalidad: record.infoAdicional.modalidad,
        }
        
        let extraContent = '';
        
        // Si es patrocinador, se le muestra el enlace para comprobar el pago realizado 
        if (record.tipoRegistro === 'Patrocinador') {
            extraContent += createButton(`/sina2025/comprobar-pago/${ record.registroReferencia }`, 'Subir comprobante de pago / Upload proof of payment');
        }

        // Si no es patrocinador ni asistente, se le muestra el enlace para editar su registro
        if (record.tipoRegistro !== 'Patrocinador' && record.infoAdicional.modalidad === 'Participante') {
            extraContent += createButton(`/sina2025/trabajos/edicion?id=${ record.registroReferencia }`, 'Gestionar trabajos / Works management');
        }

        // Si no es patrocinador, se le muestra el enlace para concurso a foto
        if (record.tipoRegistro !== 'Patrocinador') {
            extraContent += createButton(`/sina2025/concurso-fotografia/${ record.registroReferencia }`, '¡CONCURSO DE FOTO! / PHOTO CONTEST!');
        }

        // Si no es patrocinador, se le muestra el enlace para concurso a foto
        if (record.infoAdicional.modalidad === 'Asistente') {
            extraContent += createButton(`/sina2025/comprobar-pago/${ record.registroReferencia }`, 'Subir comprobante de pago / Upload proof of payment');
        }

        // const recordToStore = {
        //     ...record,
        //     infoAdicional: JSON.stringify(recordToShow.infoAdicional), 
        // }
        
        const msgbody = renderToString( 
            setBodyFirstMail({ 
                datosParticipante: record, 
                datosRegistro, 
                contenidoExtra: extraContent,
            })
        );

        // - Se genera el cc
        let toccAddresses = (process.env.REACT_APP_TOBCC_FACTURACION !== '') ? datosRegistro.correoEvento : '';

        const emailObj = {
            "toemail": record.partCorreo,
            "subject": `Recordatorio: Registro en línea | ${ datosRegistro.tituloEvento }`,
            "message": msgbody,
            "replyto": datosRegistro.correoEvento,
            "tocc": toccAddresses,
            "tobcc": 'eventos.cibnor@cibnor.mx',
        };
        // console.log({emailObj});

        const emailResult = await sendEmail(emailObj);
        console.log(emailResult);
        
        setisDataLoaded(true);

        Swal.fire({
            title: 'Correo enviado',
            // text: 'Consulte su correo para mayor información / Check your email for more information.',
            icon: 'success',
            timer: 3000,
            // showConfirmButton: false,
        })

    }

    const handleNotificar = async() => {
        setisDataLoaded(false);
        logObject(record);

        const datosRegistro = {
            tituloEvento: 'Simposio Internacional en Nutrición Acuícola',
            correoEvento: 'sina2025@cibnor.mx',
            urlLogo: eventLogo,
            modalidad: record.infoAdicional.modalidad
        }

        const msgbody = renderToString( 
            setBodyNotification({ 
                datosParticipante: record, 
                datosRegistro, 
            })
        );

        const emailObj = {
            "toemail": record.partCorreo,
            "subject": `Work review | ${ datosRegistro.tituloEvento }`,
            "message": msgbody,
            "replyto": datosRegistro.correoEvento,
            "tocc": process.env.REACT_APP_TOBCC_FACTURACION !== '' ? datosRegistro.correoEvento : '',
            "tobcc": 'eventos.cibnor@cibnor.mx',
        };

        const emailResult = await sendEmail(emailObj);
        console.log(emailResult);
        setisDataLoaded(true);
        Swal.fire({
            title: 'Participante notificado!',
            text: 'Puede cerrar la ventana o continuar modificando.',
            showConfirmButton: false,
            timer: 3000
        })
    }

    const handleEnlaceInicial = async() => {
        setisDataLoaded(false);
        
        const datosRegistro = {
            tituloEvento: 'Simposio Internacional en Nutrición Acuícola',
            correoEvento: 'sina2025@cibnor.mx',
            urlLogo: eventLogo,
            modalidad: record.infoAdicional.modalidad,
            urlPersonal: `https://cib-eventos.vercel.app/auth/new-account?email=${ record.partCorreo }&eventId=${ record.eventoId }`,
        }
        
        const msgbody = renderToString( 
            setBodyPersonalEmailLink({ 
                datosParticipante: record, 
                datosRegistro, 
            })
        );
        
        const emailObj = {
            "toemail": record.partCorreo,
            "subject": `Set a password | ${ datosRegistro.tituloEvento }`,
            "message": msgbody,
            "replyto": datosRegistro.correoEvento,
            "tocc": process.env.REACT_APP_TOBCC_FACTURACION !== '' ? datosRegistro.correoEvento : '',
            "tobcc": 'eventos.cibnor@cibnor.mx',
        };

        const emailResult = await sendEmail(emailObj);
        console.log(emailResult);
        setisDataLoaded(true);
        Swal.fire({
            title: 'Enlace personal enviado',
            showConfirmButton: false,
            timer: 3000
        })
    }


    //* Se recupera y formatea la data
    useEffect(async() => {

        const { data } = await getByRegistroReferencia(ref);
        const recordTmp = data[0];

        const infoAdicional = JSON.parse(recordTmp.infoAdicional);
        setWorks(infoAdicional.trabajos);

        const recordToShow = { ...recordTmp, infoAdicional: infoAdicional };
        console.log({recordToShow})
        // logObject(recordToShow.infoAdicional)
        setRecord(recordToShow);

        setisDataLoaded(true);
    }, [ ref ])


    return (
    <ThemeProvider theme={createTheme()}>

    <CustomDialog title='Por favor espere / Please wait' show={ !isDataLoaded } />
    {
        isDataLoaded && 
        <Container component="main">
        <CssBaseline />

        <Box m={ 2 } display='flex' flexDirection='row' alignItems='center'>
            <Avatar src='https://aena.mx/images/nicepage-images/80f8a68a08b4341bcc455d466709dc31.png' sx={{ width: 100, height: 'auto', px: 2 }} />
            <Box>
                <Typography fontSize={ 20 } fontWeight={ 900 }>Simposio Internacional en Nutrición Acuícola</Typography>
                <Typography fontSize={ 20 }>Revisión de trabajos</Typography>
            </Box>
        </Box>
            <Paper elevation={ 4 } sx={{ mx: 2, p: 2 }}>
                <Grid container spacing={ 2 }>
                    <Grid item xs={ 6 }>
                        <Typography fontSize={ 24 } fontWeight={ 900 }>
                            { `${ record.partApellidoPaterno } ${ record.partApellidoMaterno } ${ record.partNombres }` }
                        </Typography>
                        <Typography color='blue'>{ record.partCorreo }</Typography>
                        <Typography>{ ref }</Typography>
                    </Grid>
                    <Grid item xs={ 6 }>
                        <Typography>Modalidad: <strong>{ record.infoAdicional.modalidad }</strong></Typography>
                        <Typography>Ocupación/puesto: <strong>{ record.tipoRegistro }</strong></Typography>
                        {
                            record.tipoRegistroDocURL !== ''
                            ? <a href={ record.tipoRegistroDocURL } target='_blank'>Consultar documento</a>
                            : <></>
                        }
                        <Typography>Concurso, poster: <strong>{ record.infoAdicional.concursoPoster === '1' ? 'Si' : 'No' }</strong></Typography>
                        <Typography>Concurso, fotografía: <strong>{ record.infoAdicional.concursoFoto === '1' ? 'Si' : 'No' }</strong></Typography>
                        
                        {
                            ( record.infoAdicional.concursoFotoArchivos )
                            ? <>
                                { 
                                    Object.keys(record.infoAdicional.concursoFotoArchivos).map((k, i) =>
                                        <Tooltip 
                                            key={ i } 
                                            title={ k.replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase() }
                                        >
                                            <IconButton href={ record.infoAdicional.concursoFotoArchivos[k] } target='_blank'>
                                                <DescriptionOutlinedIcon color='primary' />
                                            </IconButton>
                                        </Tooltip>
                                    )
                                }
                            </>
                            : <Typography fontStyle='italic'>Carga de archivos pendiente</Typography>
                        }
                        
                    </Grid>

                    <Grid item xs={ 12 }><Divider sx={{ my: 1 }}/></Grid>

                    <Grid item xs={ 12 }>

                        <Typography>Total de trabajos: <strong>{ works.length }</strong></Typography>
                        {
                            works.map(work =>
                                <Box key={ work.id } my={ 1 } p={ 1 } sx={{ border: '1px solid lightblue' }}>
                                    <Typography fontStyle='italic' fontSize={ 16 }>{ work.title }</Typography>
                                    <Box 
                                        display={ record.infoAdicional.modalidad === 'Participante' ? 'flex' : 'none' } 
                                        flexDirection='column'
                                    >

                                        <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                                            <Typography fontSize={ 14 } align='center'>
                                                Nombre del archivo: <strong>
                                                    { work.url.slice( work.url.lastIndexOf('/') + 1) }
                                                </strong>
                                            </Typography>
                                            <a href={ work.url } download="MyExampleDoc" target='_blank'>
                                                <Button variant='contained' size='small'>Descargar</Button>
                                            </a>
                                        </Box>
                                    </Box>

                                    <Box display={ work.mediaFilesURL !== '' ? 'flex' : 'none' } pb={ 1 }>
                                        <a href={ `${ work.mediaFilesURL }`} target='_blank'>Consultar archivos multimedia</a>
                                    </Box>
                                    
                                    <FormControl fullWidth sx={{ mt: 3, mb: 2 }}>
                                        <InputLabel sx={{ color: 'blue' }}>Status</InputLabel>
                                        <Select
                                            value={ work.status }
                                            onChange={ handleWorkStatusChanged }
                                            variant='standard'
                                            name={ work.id }
                                        >
                                            <MenuItem value={ 'devuelto' }>devuelto</MenuItem>
                                            <MenuItem value={ 'entregado' }>entregado</MenuItem>
                                            <MenuItem value={ 'aceptado' }>aceptado</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <TextField
                                        fullWidth
                                        id={ work.id }
                                        label={ 'Comentarios en caso de devolución del trabajo' }
                                        maxRows={ 8 }
                                        minRows={ 2 }
                                        multiline
                                        name={ work.id }
                                        onChange={ handleWorkCommentsChanged }
                                        variant={ 'outlined' }
                                        value={ work.statusComments }
                                    />
                                        
                                </Box>
                            )
                        }

                        <Box pb={ 1 } display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                            <Button 
                                variant='contained' 
                                onClick={ handleGuardarCambios }
                                size='small'
                                color='success'
                            >
                                Guardar cambios
                            </Button>
                            <Box gap={ 1 } display='flex' flexDirection='row'>

                                <Button 
                                    variant='contained' 
                                    onClick={ handleReenviarRecordatorio }
                                    size='small'
                                    color='info'
                                >
                                    Reenviar correo (recordatorio)
                                </Button>
                                <Button 
                                    variant='contained' 
                                    onClick={ handleNotificar }
                                    size='small'
                                    color='warning'
                                    sx={{ display: record.infoAdicional.modalidad !== 'Participante' ? 'none' :'flex' }}
                                >
                                    Notificar al participante
                                </Button>

                                <Button 
                                    variant='outlined' 
                                    onClick={ handleEnlaceInicial }
                                    size='small'
                                    color='error'
                                >
                                    Enviar enlace inicial personalizado
                                </Button>

                            </Box>
                        </Box>

                    </Grid>


                </Grid>
            </Paper>

        </Container>
    }
    </ThemeProvider>
    )
}
